import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  sendPasswordResetEmail,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import I18n from "i18n-js";
import { parentsFirebase } from "app/Auth";
import Constants from "common/constant";
import { usePlaySound } from "common/utils";
import { Footer } from "features/home";
import { BackBtn } from "./BackBtn";
import { MobileInput } from "./AuthStyles";

export const PasswordResetScreen = () => {
  const navigate = useNavigate();
  const playSound = usePlaySound();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);

  const handlePasswordReset = async () => {
    playSound();
    if (!email) {
      setError(I18n.t("MSG_SIGN_EMAIL_REQUIRED"));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(I18n.t("MSG_SIGN_EMAIL_INVALID"));
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const auth = getAuth(parentsFirebase);
      const methods = await fetchSignInMethodsForEmail(auth, email);
      if (methods.includes("password")) {
        await sendPasswordResetEmail(auth, email);
      }
      setIsEmailSent(true);
    } catch (err) {
      setError(I18n.t("MSG_SIGN_PASSWORD_RESET_FAILED"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    playSound();
    navigate("/auth/email-login");
  };

  return (
    <div className="flex-col-el flex-center w-full h-full">
      <img
        alt="*"
        src={`${Constants.assetHost}/assets/images/new_bg_puzzle.png`}
        className="absolute inset-0 object-cover w-full h-full z-[-1]"
      />

      <BackBtn />
      <div className="flex-col-el relative overflow-y-auto w-full max-h-screen">
        <div className="flex-col-el flex-center w-full h-full max-w-md mx-auto">
          <div className="flex-col-el flex-center p-4 w-full">
            <div className="flex-col-el w-full gap-4">
              {!isEmailSent ? (
                <>
                  <div className="flex-col-el flex-center">
                    <p
                      className="text-3xl my-2 text-center"
                      style={{ color: "var(--color-ink)" }}
                    >
                      {I18n.t("MSG_SIGN_IN_FORGOT_PASSWORD_TITLE")}
                    </p>
                  </div>
                  {/* メールアドレス入力 */}
                  <MobileInput
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setError("");
                      setEmail(e.target.value);
                    }}
                    placeholder={I18n.t("MSG_SIGN_USER_MAIL")}
                    label={I18n.t("MSG_SIGN_USER_MAIL")}
                    disabled={isLoading}
                    className={
                      error && !email ? "!border-red-500 !bg-red-50" : ""
                    }
                  />
                  {error && (
                    <p className="text-body text-sm text-red-500 text-center">
                      {error}
                    </p>
                  )}

                  {/* 説明テキスト */}
                  <p className="text-body text-xs text-center text-textcolor-black">
                    {I18n.t("MSG_SIGN_PASSWORD_RESET_DESCRIPTION")}
                  </p>

                  {/* リセットメール送信ボタン */}
                  <div className="flex-col-el flex-center w-full gap-4 upsilon">
                    <button
                      className="btn btn-primary w-[375px] h-[40px]"
                      onClick={handlePasswordReset}
                    >
                      <p className="text-body text-base">
                        {I18n.t("MSG_SIGN_PASSWORD_RESET_SEND_BTN")}
                      </p>
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* 成功メッセージ */}
                  <div className="flex-col-center text-center gap-4 w-full">
                    <div className="flex-col-el flex-center gap-4 w-full">
                      <div className="flex-row-el flex-center gap-2">
                        <div className="text-2xl">✅</div>
                        <p className="text-subtitle text-2xl text-ink">
                          {I18n.t("MSG_SIGN_EMAIL_SENT")}
                        </p>
                      </div>

                      <p className="text-subtitle2 text-2xl text-ink break-all whitespace-pre max-sm:whitespace-pre-line">
                        {email}
                      </p>
                      <p className="text-caption text-sm text-center w-full text-ink break-all whitespace-pre max-sm:whitespace-pre-line">
                        {I18n.t("MSG_SIGN_PASSWORD_RESET_SENT")}
                      </p>
                    </div>
                  </div>

                  <div className="flex-col-el flex-center w-full gap-4 upsilon">
                    <button
                      className="btn btn-primary w-[375px] h-[40px]"
                      onClick={handleBackToLogin}
                    >
                      <p className="text-body text-base">
                        {I18n.t("MSG_SIGN_BACK_TO_LOGIN")}
                      </p>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
